<script>
import Layout from '../../layouts/main'
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { extend } from '@syncfusion/ej2-base';
import { CheckBoxComponent } from '@syncfusion/ej2-vue-buttons';
import { roomData } from './datasource';
import { ScheduleComponent, ViewDirective, ViewsDirective, ResourceDirective, ResourcesDirective, TimelineViews, Resize, DragAndDrop } from "@syncfusion/ej2-vue-schedule";


export default {
  page: {
    title: "",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader,
    'ejs-schedule': ScheduleComponent,
    'e-view': ViewDirective,
    'e-views': ViewsDirective,
    'e-resource': ResourceDirective,
    'e-resources': ResourcesDirective,
    'ejs-checkbox': CheckBoxComponent
  },
  data() {

    return {
      title: "Página em Contrução",
      items: [
        {
          text: "Home",
          href: "/"
        },
        {
          text: "Página em Contrução",
          active: true
        }
      ],

      cssClass: 'adaptive-rows',
      eventSettings: {
        dataSource: extend([], roomData, null, true),
        fields: {
          id: 'Id',
          subject: { name: 'Subject', title: 'Summary' },
          location: { name: 'Location', title: 'Location' },
          description: { name: 'Description', title: 'Comments' },
          startTime: { name: 'StartTime', title: 'From' },
          endTime: { name: 'EndTime', title: 'To' }
        }
      },
      selectedDate: new Date(2021, 7, 2),
      currentView: 'TimelineWeek',
      group: {
        enableCompactView: false,
        resources: ['MeetingRoom']
      },
      meetingRoomDataSource: [
        { text: 'Pessoa A', id: 1, color: '#98AFC7' },
        { text: 'Pessoa B', id: 2, color: '#99c68e' },
        { text: 'Pessoa C', id: 3, color: '#C2B280' },
        { text: 'Pessoa D', id: 4, color: '#3090C7' },
        { text: 'Pessoa E', id: 5, color: '#95b9' },
        { text: 'Pessoa F', id: 6, color: '#95b9c7' },
        { text: 'Pessoa G', id: 7, color: '#deb887' },
        { text: 'Pessoa H', id: 8, color: '#3090C7' },
        { text: 'Pessoa I', id: 9, color: '#98AFC7' },
        { text: 'Pessoa J', id: 10, color: '#778899' }
      ],
    }
  },
  created() {

  },
  mounted() {

  },
  provide: {
    schedule: [TimelineViews, Resize, DragAndDrop]
  },
  methods: {
    onChange: function (args) {
      this.$refs.ScheduleObj.ej2Instances.rowAutoHeight = args.checked;
    }
  }

};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div>

      <div class="schedule-vue-sample">
        <div class="col-md-12 control-section">
          <div class="content-wrapper">
            <ejs-schedule id='Schedule' ref="ScheduleObj" :cssClass="cssClass" width="100%" height="100%"
                          :rowAutoHeight="true" :selectedDate='selectedDate' :currentView='currentView'
                          :eventSettings='eventSettings' :group='group'>
              <e-views>
                <e-view option="TimelineDay"></e-view>
                <e-view option="TimelineWeek"></e-view>
              </e-views>
              <e-resources>
                <e-resource field='RoomId' title='Room Type' name='MeetingRoom' allowMultiple=true
                            :dataSource='meetingRoomDataSource' textField='text'
                            idField='id' colorField='color'>
                </e-resource>
              </e-resources>
            </ejs-schedule>
          </div>
        </div>
        <div class="col-lg-3 property-section">
          <div id="property" class="property-panel-table" title="Properties">
            <table id="property" title="Properties" style="width: 100%">
              <tbody>
              <tr style="height: 50px">
                <td style="width: 100%">
                  <ejs-checkbox label="Row Auto Height" :checked="true" :change="onChange"></ejs-checkbox>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>

    </div>


  </Layout>
</template>

<style>
.schedule-vue-sample .adaptive-rows.e-schedule .e-timeline-view .e-resource-left-td {
  width: 120px;
}

.schedule-vue-sample .adaptive-rows.e-schedule .e-timeline-view .e-resource-text {
  padding-left: 20px;
}

.schedule-vue-sample .adaptive-rows.e-schedule .e-timeline-view .e-block-appointment {
  align-items: center;
  display: flex;
  justify-content: center;
}
</style>